import React, { memo } from 'react'
import { Path, Circle as _Circle } from 'react-native-svg'

import { IconBase } from '../IconBase'
import { IconProps } from '../IconProps'
import { themed } from '../themed'

const Icon = (props) => {
  const { size = 24, ...otherProps } = props
  return (
    <IconBase
      width={size}
      height={size}
      viewBox="0 0 42 42"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <Path
        d="M27.6875 9H31.5219L23.1469 18.7425L33 32H25.2859L19.2438 23.9579L12.3297 32H8.49375L17.4516 21.5786L8 9H15.9109L21.3719 16.3489L27.6875 9ZM26.3437 29.6651H28.4688L14.7547 11.2128H12.4766L26.3437 29.6651Z"
        fill="#fff"
      />
    </IconBase>
  )
}

Icon.displayName = 'IconTwitter'

export const IconTwitter = memo<IconProps>(themed(Icon))
